import { Button, useDeviceType } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { ValuationNotFound, ValuationReady } from './components';
import * as styles from './styles.css';

export interface IValuationSearchProps {
  isLoading: boolean;
  disabled: boolean;
  isNotFound: boolean;
  isEstimationReady: boolean;
  submitText: string;

  onEstimationReadyClick(): void;
  onClick(): void;
}

export const OpenDataPaymentForm: React.FC<IValuationSearchProps> = ({
  isLoading,
  disabled,
  onClick,
  onEstimationReadyClick,
  isNotFound,
  isEstimationReady,
  submitText,
}) => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div {...mergeStyles(styles['container'], isDesktop ? styles['container_desktop'] : styles['container_mobile'])}>
      {isNotFound && (
        <div className={styles['message']}>
          <ValuationNotFound isDesktop={isDesktop} />
        </div>
      )}
      {isEstimationReady && (
        <div className={styles['message']}>
          <ValuationReady isDesktop={isDesktop} onClick={onEstimationReadyClick} />
        </div>
      )}
      <div className={styles['action']}>
        <Button size="M" loading={isLoading} disabled={disabled} onClick={onClick} fullWidth>
          {submitText}
        </Button>
      </div>
    </div>
  );
};

OpenDataPaymentForm.displayName = 'OpenDataPaymentForm';
